import { useState, useEffect } from "react";
import DoughnutChart from "../../../components/admin/DoughnutChart";
import FilterIcon from "../../../utils/assets/client/filter.svg";
import { fetchAllTickets } from "../../../actions/admin/tickets";
import { Link } from "react-router-dom";
import { fetchAllInvoices } from "../../../actions/admin/invoice";
import Badge from "../../../components/admin/Badge";

const ManageInvoices = () => {
  const [invoiceData, setInvoiceData] = useState([]);
  const [SearchData, setSearchData] = useState({
    invoiceID: "",
    name: "",
    ticketID: "",
    status: "",
    date: "",
  });
  const [invoiceSearchdata, setInvoiceSearchData] = useState([])

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetchAllInvoices(token).then((res) => {
      setInvoiceData(res.data);
      setInvoiceSearchData(res.data)
    });
  }, []);


  const handleFilterChange = (values) => {
    // Update filters state
    // Filter data
    const filtered = invoiceData.filter((item) => {
      const invoiceIDMatch = !SearchData.invoiceID || item.id.toString().includes(SearchData.invoiceID.toString().trim());
  
      const customer = item?.ticket?.lead?.customer;
      const customerName = customer ? `${customer.first_name} ${customer.last_name}`.toLowerCase() : "";
      const nameMatch = !SearchData.name || customerName.includes(SearchData.name.toLowerCase().trim());
  
      const ticketMatch = !SearchData.ticketID || item?.ticket?.ticket_id?.toString().toLowerCase().includes(SearchData.ticketID.toLowerCase().trim())
        // item?.ticket?.ticket_id?.toLowerCase() === SearchData.ticketID.toLowerCase();
  
      const statusMatch = !SearchData.status || 
        item.status.toLowerCase().includes(SearchData.status.toLowerCase());
  
      const dateMatch = !SearchData.date || 
        item.created_at.slice(0, 10) === SearchData.date; // expected format: YYYY-MM-DD
  
      return invoiceIDMatch && nameMatch && ticketMatch && statusMatch && dateMatch;
    });
    console.log("worked", filtered);

    setInvoiceSearchData(filtered)
    // setIsLoading(true)
    // setTimeout(() => {
    // setFilteredData(filtered);
    // setIsLoading(false)
    // }, 1000)
  };
  const labelData = [
    "Won",
    "Lost",
    "Open",
    "In Progress",
    "Expired",
    "Cancelled",
  ];

  const dataSetValue = [10, 15, 12, 11, 23, 20, 1];

  return (
    <div className="bg-light">
      <div className="d-flex justify-content-between align-items-center p-3">
        <h4 className="m-0 ">Manage Invoices</h4>
        <button className="btn  bg-black text-white py-2 px-3 border-0">
          Create Ticket
        </button>
      </div>
      <div className="card_radius  card mb-3 m-3 mt-0">
        <div className="row d-flex justify-content-start align-items-center p-3">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Invoice ID</label>
            <input
              type="text"
              className="form-control"
              value={SearchData.invoiceID}
              onChange={(e) =>
                setSearchData({ ...SearchData, invoiceID: e.target.value })
              }
              placeholder="Enter Ticket ID"
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Customer Name</label>
            <input
              type="text"
              className="form-control"
              value={SearchData.name}
              onChange={(e) =>
                setSearchData({ ...SearchData, name: e.target.value })
              }
              placeholder="Enter customer name"
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Ticket ID</label>
            <input
              type="text"
              className="form-control"
              value={SearchData.ticketID}
              onChange={(e) =>
                setSearchData({ ...SearchData, ticketID: e.target.value })
              }
              placeholder="Enter Ticket ID"
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Invoice Status</label>
            <input
              type="text"
              className="form-control"
              value={SearchData.status}
              onChange={(e) =>
                setSearchData({ ...SearchData, status: e.target.value })
              }
              placeholder="Enter Ticket Status"
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Created Date</label>
            <input
              type="date"
              className="form-control"
              value={SearchData.date}
              onChange={(e) =>
                setSearchData({ ...SearchData, date: e.target.value })
              }
              placeholder="Enter date"
            />
          </div>
        </div>
        <div className="my-1 px-3 pb-3">
          <button onClick={() => setInvoiceSearchData(invoiceData)} className="btn btn-sm bg-black  text-white p-2 px-3 border-0">
            <img width={20} src={FilterIcon} alt="filter" />{" "}
            <span>Clear Filter</span>
          </button>
          <button
            onClick={handleFilterChange}
            className="btn btn-sm  bg-black text-white py-2 px-3 mx-2 border-0"
          >
            Search
          </button>
        </div>
      </div>
      {/* Doughnut Charts start */}

      <div className="my-3 mx-4">
        <div className="row  border_bg_col overflow-hidden">
          <p className="txt-head bg-black text-white px-3 mb-0 p-2">View Invoice (s)</p>
          <table className="table table-hover mb-0">
            <thead>
              <tr className="p-2">
                <td className="px-3">Invoice ID</td>
                <td>Customer Name</td>
                <td>Ticket ID</td>
                <td>Amount</td>
                <td>Tax</td>
                <td>Payment Type</td>
                <td>Paid Amount</td>
                <td>Status</td>
                <td>More</td>
              </tr>
            </thead>
            <tbody className="" >
              {invoiceSearchdata.length > 0
                ? invoiceSearchdata.map((item) => {
                    return (
                      <tr className="p-3" key={item.id}>

                        <td className="px-3"> <Link className="link_text " style={{fontWeight: "400"}}> {item.id} </Link> </td>
                        <td>{item.ticket.lead.customer.first_name} {item.ticket.lead.customer.last_name}</td>
                        <td><Link to={'/admin/tickets/'+item.ticket_id} className="link_text " style={{fontWeight: "400"}}> {item.ticket.ticket_id} </Link></td>
                        <td>£ {item.total_price}</td>
                        <td>£ {item.total_tax}</td>
                        <td>{item.payment_method}</td>
                        <td>£ {item.paid_amount}</td>
                        <td>
                          <Badge title={item.status}
                            color_code={item.color_code} />
                        </td>
                        <td>More</td>
                      </tr>
                    );
                  })
                : (
                  <tr>
                    <td
                      colspan="11"
                      className="table-active text-center txt-p py-2"
                      style={{fontWeight: "500"}}
                    >
                      No Records
                    </td>
                  </tr>
                )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ManageInvoices;
